import { SelectionList, Text } from '@dixa/lib-shared-habla';
import type {
  SearchFilterCondition,
  SearchFilterOperatorExistence,
} from 'lib-search-types';
import { SearchFilterLayout } from 'lib-search-ui';
import { useCallback } from 'react';

import { CustomFieldAttribute } from 'apis/customFields';

import { ContactsFilterOptions } from '../../../../options/contactsFilterOptions';

const operators: {
  value: SearchFilterOperatorExistence;
  label: string;
}[] = [
  { value: 'is_empty', label: 'no value' },
  { value: 'is_not_empty', label: 'any value' },
];

type ContactsFilterAttributesTextProps = {
  attribute: CustomFieldAttribute;
  condition: SearchFilterCondition<'users'> | undefined;
  onChange: (
    condition: SearchFilterCondition<'users'> | null,
    attributeId: string,
  ) => void;
  onBack: () => void;
};

export function ContactsFilterAttributesText({
  attribute,
  condition,
  onChange,
  onBack,
}: ContactsFilterAttributesTextProps): JSX.Element {
  const selectedOperator = condition?.operator as
    | SearchFilterOperatorExistence
    | undefined;

  const handleChangeOperator = useCallback(
    (newOperator: SearchFilterOperatorExistence) => {
      onChange(
        {
          field: 'contact_custom_attribute',
          operator: newOperator,
          values: [],
          attributeId: attribute.id,
        },
        attribute.id,
      );
    },
    [attribute.id, onChange],
  );

  const handleClear = useCallback(() => {
    onChange(null, attribute.id);
  }, [attribute.id, onChange]);

  return (
    <>
      <SearchFilterLayout.Row>
        <Text.Paragraph variant="3" subdued>
          {attribute.label}
        </Text.Paragraph>
      </SearchFilterLayout.Row>

      <SearchFilterLayout.Row noPadding>
        {/* Wrapping `BackItem` in an inactive `SelectionList` enables hover state. */}
        <SelectionList isActive={false}>
          <SelectionList.BackItem onSelected={onBack} />
        </SelectionList>
      </SearchFilterLayout.Row>

      <SearchFilterLayout.Row borderTop>
        <ContactsFilterOptions
          isDefaultOpen
          operators={operators}
          selectedOperator={selectedOperator}
          onChangeOperator={handleChangeOperator}
          onClear={handleClear}
        />
      </SearchFilterLayout.Row>
    </>
  );
}
